// extracted by mini-css-extract-plugin
var _1 = "forgotPassword-module_check_sZOOk";
var _2 = "forgotPassword-module_forgotBtn_BiUeq";
var _3 = "forgotPassword-module_forgotButtonWrapper_O6WNt";
var _4 = "forgotPassword-module_forgotForm_foYRN";
var _5 = "forgotPassword-module_forgotPrevbuttonWrapper_FRdjI";
var _6 = "forgotPassword-module_loginSupportLink_JnuK6";
var _7 = "forgotPassword-module_loginSupportText_gCi6G";
var _8 = "forgotPassword-module_loginSupportWrapper_yZQ6C";
export { _1 as "check", _2 as "forgotBtn", _3 as "forgotButtonWrapper", _4 as "forgotForm", _5 as "forgotPrevbuttonWrapper", _6 as "loginSupportLink", _7 as "loginSupportText", _8 as "loginSupportWrapper" }
